// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/user-profile/app/css/app.css
// module id = 780
// module chunks = 0